import { render, staticRenderFns } from "./ICUser.vue?vue&type=template&id=0d2f2822&scoped=true"
import script from "./ICUser.vue?vue&type=script&lang=js"
export * from "./ICUser.vue?vue&type=script&lang=js"
import style0 from "./ICUser.vue?vue&type=style&index=0&id=0d2f2822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f2822",
  null
  
)

export default component.exports